<template>
    <div class="study-product-course-list">
        <carousel v-if="courses.length >= 5" :responsive="{0:{items:1},1100:{items:5}}" :margin="0">
            <StudyProductCourseItem v-for="item in courses"
                                    :key="item.idcourse"
                                    :course="item"
                                    @about="about"/>
        </carousel>
        <div v-else-if="courses.length > 0 &&  courses.length < 5">
            <StudyProductCourseItem v-for="item in courses"
                                    :key="item.idcourse"
                                    :course="item"
                                    @about="about"/>
        </div>
    </div>
</template>

<script>
    import carousel from 'vue-owl-carousel'
    import StudyProductCourseItem from "./StudyProductCourseItem";

    export default {
        name: "StudyProductCourseList",
        components: {
            StudyProductCourseItem,
            carousel,
        },
        props: {
            courses: {
                type: Array,
                required: true,
            },
        },
        methods: {
            about(course) {
                this.$emit('about', course)
            },
        }
    }
</script>

<style>
    @media (min-width: 1000px) {
        .study-product-course-list .owl-item {
            margin-right: -3px;
        }
    }

    @media (max-width: 999px) {
        .study-product-course-list .owl-item {
            margin-right: auto;
            margin-left: auto;
        }
    }
</style>
